/// <amd-module name="Build/Admin/Common/Stores/AgentCloudStore" />
import { Store } from "VSS/Reflux/Store";

import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";

import { TaskAgentCloud } from "DistributedTask/Client/Contracts/TaskAgent";

export class AgentCloudStore extends Store {
    public state: TaskAgentCloud[] = [];

    constructor() {
        super("AgentCloudStoreChanged");
    }

    public getAgentCloudById(agentCloudId: number): TaskAgentCloud | undefined {
        const matchingAgentClouds: TaskAgentCloud[] = this.state.filter(agentCloud => agentCloud.agentCloudId === agentCloudId);
        return matchingAgentClouds[0];
    }

    public updateAgentClouds = (agentClouds: TaskAgentCloud[]): void => {
        this.state = this._sortAgentClouds(agentClouds.slice(0));
        this.emitChanged();
    }

    public addOrUpdateAgentCloud = (agentCloud: TaskAgentCloud): void => {
        // If an existing cloud with this ID exists, filter it out
        const allOtherClouds: TaskAgentCloud[] = this.state.filter(existingAgentCloud => existingAgentCloud.agentCloudId !== agentCloud.agentCloudId);

        // Now add the new object and re-sort
        this.state = this._sortAgentClouds(allOtherClouds.concat([agentCloud]));
        this.emitChanged();
    }

    public deleteAgentCloud = (agentCloud: TaskAgentCloud): void => {
        this.state = this.state.filter(existingAgentCloud => existingAgentCloud.agentCloudId !== agentCloud.agentCloudId);
        this.emitChanged();
    }

    private _sortAgentClouds(agentClouds: TaskAgentCloud[]): TaskAgentCloud[] {
        return (agentClouds).sort((a, b) => {
            return localeIgnoreCaseComparer(a.name, b.name);
        });
    }
}
